import SvgIcon from "@mui/material/SvgIcon";

export const ReferralsListIcon = (props) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill="#fff"
        d="M20.842 7.579a1.895 1.895 0 110-3.79 1.895 1.895 0 010 3.79zm0-3.158a1.263 1.263 0 100 2.526 1.263 1.263 0 000-2.526zM20.842 17.684a1.895 1.895 0 110-3.79 1.895 1.895 0 010 3.79zm0-3.158a1.263 1.263 0 100 2.526 1.263 1.263 0 000-2.526zM23.684 10.736H20.21v-.631h3.158v-.632a1.858 1.858 0 00-.556-1.335l-.225-.221.423-.469.237.232A2.492 2.492 0 0124 9.473v.948a.316.316 0 01-.316.315zM23.684 20.842H20.21v-.632h3.158v-.632a1.858 1.858 0 00-.556-1.335l-.225-.22.423-.47.237.232A2.493 2.493 0 0124 19.578v.948a.316.316 0 01-.316.316zM4.421 12.631a2.526 2.526 0 110-5.052 2.526 2.526 0 010 5.052zm0-4.42a1.895 1.895 0 100 3.789 1.895 1.895 0 000-3.79z"></path>
      <path
        fill="#fff"
        d="M8.526 17.052H.316A.315.315 0 010 16.736v-.315a4.395 4.395 0 012.068-3.741l.267-.168.336.534-.267.168a3.766 3.766 0 00-1.772 3.207H8.21a3.79 3.79 0 00-1.109-2.684 3.601 3.601 0 00-.66-.522l-.27-.164.329-.54.27.165c.282.174.544.38.779.615a4.418 4.418 0 011.292 3.13v.316a.316.316 0 01-.316.315zM8.842 12h5.684v.947H8.842V12z"></path>
      <path
        fill="#fff"
        d="M13.567 11.967l3.572-3.573.67.67-3.573 3.572-.67-.67z"></path>
      <path
        fill="#fff"
        d="M14.236 12.183l3.573 3.573-.67.67-3.572-3.573.67-.67z"></path>
    </svg>
  </SvgIcon>
);
